"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConferenceEvent = void 0;
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
let ConferenceEvent = class ConferenceEvent extends mocks_1.Model {
};
exports.ConferenceEvent = ConferenceEvent;
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, required: true, index: true }),
    __metadata("design:type", String)
], ConferenceEvent.prototype, "conferenceId", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.CallMetricsEventEnum, required: true }),
    __metadata("design:type", String)
], ConferenceEvent.prototype, "event", void 0);
__decorate([
    (0, property_1.Property)({ allowMixed: 0 }),
    __metadata("design:type", Object)
], ConferenceEvent.prototype, "data", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId }),
    __metadata("design:type", String)
], ConferenceEvent.prototype, "userId", void 0);
exports.ConferenceEvent = ConferenceEvent = __decorate([
    (0, mocks_1.index)({ conferenceId: 1, createdAt: -1 })
], ConferenceEvent);
